"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUnauth = exports.Unauth = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const UnauthContext = /*#__PURE__*/(0, _react.createContext)();
const useUnauth = () => (0, _react.useContext)(UnauthContext);

// Possible matches:
// m.veepee.xx
// m-preprod.veepee.xx
// preprod.veepee.xx
// veepee.xx
// preprod-xx.privalia.com
// xx.privalia.com
// m.xx.privalia.com
// preprod-xx.mobile.privalia.com
exports.useUnauth = useUnauth;
const unauthPrivalia = country => {
  switch (country) {
    case 'es':
      return {
        locale: 'es-ES',
        siteId: 66,
        isPrivalia: true
      };
    case 'it':
      return {
        locale: 'it-IT',
        siteId: 69,
        isPrivalia: true
      };
    default:
      // eslint-disable-next-line no-console
      console.warn('unrecognized country, returning fallback', country);
      return {
        locale: 'en',
        isPrivalia: true
      };
  }
};
const unauthVeepee = country => {
  switch (country) {
    case 'fr':
      return {
        locale: 'fr-FR',
        siteId: 1
      };
    case 'de':
      return {
        locale: 'de-DE',
        siteId: 2
      };
    case 'es':
      return {
        locale: 'es-ES',
        siteId: 3
      };
    case 'it':
      return {
        locale: 'it-IT',
        siteId: 4
      };
    case 'at':
      return {
        locale: 'de-AT',
        siteId: 7
      };
    case 'dk':
      return {
        locale: 'da-DK',
        siteId: 105
      };
    default:
      // eslint-disable-next-line no-console
      console.warn('unrecognized country, returning fallback', country);
      return {
        locale: 'en'
      };
  }
};
const getUnauth = hostBase => {
  const host = hostBase || window?.location?.hostname;
  const match = host && host.match(/((.*)\.)?(.+)\.(.+)/);
  if (!match) return {
    locale: 'en'
  };
  const [,, second, third, fourth] = match;
  const isPrivalia = third === 'privalia';
  const country = isPrivalia ? second.substr(-2) : fourth;
  return isPrivalia ? unauthPrivalia(country) : unauthVeepee(country);
};
const Unauth = ({
  children,
  host
}) => {
  const [unauth, setUnauth] = (0, _react.useState)(host && getUnauth(host));
  (0, _react.useEffect)(() => {
    if (!host) setUnauth(getUnauth());
  }, [host]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(UnauthContext.Provider, {
    value: unauth,
    children: children
  });
};
exports.Unauth = Unauth;
Unauth.propTypes = {
  children: _propTypes.default.node.isRequired
};